/* Xendit related configuration.

NOTE: REACT_APP_XENDIT_PUBLISHABLE_KEY is mandatory environment variable.

This variable is set in a hidden file: .env
To make Xendit connection work, you also need to set Xendit's secret key in the .env file.
*/

export const publishableKey = process.env.REACT_APP_XENDIT_PUBLISHABLE_KEY;
export const isXenditEnabled = process.env.REACT_APP_ENABLE_XENDIT === 'true';

// Xendit supports IDR currency
// We keep listings in USD in Sharetribe, but charge in IDR via Xendit
// The conversion happens automatically on the server side
export const supportedCurrencies = ['USD', 'THB'];

// Exchange rate for USD to THB conversion
// This is used on the server side in server/api-util/currencyConversion.js
// Update this value to match current exchange rates
export const usdToThbRate = 35;
